import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'

export default class VirtualRequest extends BaseModelRequest {

  builderHeader() {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();

    return headers;
  }

  getSuggestTrial(data) {
    const url = "virtual/suggest/trial";
    return this.post(url, data);
  }

  getSuggestVip(data) {
    const url = "virtual/suggest/vip_tmdt";
    return this.post(url, data);
  }

  orderPackage(data) {
    const url = "order/package";
    return this.post(url, data);
  }

  getPackages() {
    const url = "packages";
    return this.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/request/VirtualRequest.js